import Icon from '../components/Icon.vue'

Icon.register({
  'hands-helping': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M488 192c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-8v64c0 17.7-14.3 32-32 32h-16c0 35.3-28.7 64-64 64h-136.6l-103.4 59.7c-15.3 8.8-34.9 3.6-43.7-11.7l-80-138.6c-8.9-15.3-3.6-34.9 11.7-43.7l80-46.2v-47.3c0-22.4 11.8-43.3 31.1-54.8l64.9-39v121.6c0 39.7 32.3 72 72 72s72-32.3 72-72v-56h152zM635.7 154.6c8.8 15.3 3.6 34.8-11.7 43.7l-80 46.2v-28.5c0-30.9-25.1-56-56-56h-184v88c0 22.1-17.9 40-40 40s-40-17.9-40-40v-126.3c0-11 5.6-21.3 15-27.1l33.5-20.9c10.2-6.3 21.9-9.7 33.9-9.7h102.2l103.4-59.7c15.3-8.8 34.9-3.6 43.7 11.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hands-helping.js
// module id = 1436
// module chunks = 0